import getPlayfieldPosition from './playfieldPosition';
import './Explosion.css';

function Explosion({ explosion }) {
  const className = [
    'explosion',
    explosion.kind ? `explosion-${explosion.kind}` : '',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={className}
      style={getPlayfieldPosition(explosion.x, explosion.y)}
      aria-hidden="true"
    >
      <span />
    </div>
  );
}

export default Explosion;
